import React from 'react'
import PropTypes from 'prop-types'
import { createPortal } from 'react-dom'

import { CircularLoader } from '@st-operations/uikit/src/v2'

import './styles.scss'

const LoadingModal = ({ condition, message }) => (
  <If condition={condition}>
    {createPortal(
      <div className="st-loading-modal">
        <div className="st-loading-modal__content">
          {message && <p className="st-loading-modal__message">{message}</p>}
          <CircularLoader />
        </div>
      </div>,
      document.querySelector('body')
    )}
  </If>
)

LoadingModal.propTypes = {
  condition: PropTypes.bool.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
}

export default LoadingModal
